
<script>
import { useAlert } from 'dashboard/composables';

export default {
  name: 'SelectProduct',
  props: {
    selectedBranchId: {
      type: String,
      default: null,
    }
  },
  data() {
    return {
      productList: [],
      isDropdownOpen: false,
      productCurrentPage: 1,
      productTotal: 0,
      productTotalPages: 1,
      productNextPage: false,
      selectedProduct: null,
    };
  },
  watch: {
    async selectedBranchId(newVal) {
      this.productCurrentPage = 1;
      this.selectedProduct = null;
      if (newVal) {
        await this.fetchProducts();
      } else {
        this.productList = [];
        this.productTotal = 0;
        this.productTotalPages = 1;
        this.productNextPage = false;
      }
    },
    async productCurrentPage() {
      if (this.selectedBranchId) {
        await this.fetchProducts();
      }
    }
  },
  methods: {
    async fetchProducts() {
      try {
        const res = await this.$store.dispatch('rentalBranch/getActiveProducts', { branch_id: this.selectedBranchId, page: this.productCurrentPage, page_size: 10 });
        this.productList = res.results || [];
        this.productTotal = res.total || 0;
        this.productTotalPages = Math.ceil(this.productTotal / 10) || 1;
        this.productNextPage = res.next && res.next !== -1;
      } catch (err) {
        useAlert('Failed to load products');
        this.productList = [];
      }
    },
    selectProduct(product) {
      this.selectedProduct = product;
      this.$emit('selected', product);
      this.isDropdownOpen = false;
    },
    closeDropdownWithDelay() {
      setTimeout(() => {
        this.isDropdownOpen = false;
      }, 200);
    },
    nextPage() {
      if (this.productNextPage) {
        this.productCurrentPage++;
      }
    },
    prevPage() {
      if (this.productCurrentPage > 1) {
        this.productCurrentPage--;
      }
    }
  }
};
</script>

<template>
  <label class="block relative mb-4">
    <span class="text-sm font-medium text-slate-700 dark:text-slate-300">
      Select Product
    </span>
    <div
      class="overflow-hidden border-slate-200 mt-1 w-full border rounded-md text-slate-900 dark:text-white dark:bg-slate-700 dark:border-slate-600 focus-within:ring-2 focus-within:ring-woot-500"
    >
      <div
        class="reset-base w-full p-2 bg-white dark:bg-transparent border-none focus:outline-none cursor-pointer"
        @click="isDropdownOpen = true"
        tabindex="0"
        @focus="isDropdownOpen = true"
        @blur="closeDropdownWithDelay"
      >
        <span v-if="selectedProduct">
          {{ selectedProduct.product_name }}
        </span>
        <span v-else class="text-slate-400">Select a product...</span>
      </div>
      <div
        v-if="isDropdownOpen"
        class="fixed inset-0 z-40"
        @click="isDropdownOpen = false"
      ></div>
      <div
        v-if="isDropdownOpen"
        class="absolute z-50 left-0 right-0 mt-1 bg-white dark:bg-slate-700 border rounded-md shadow-lg max-h-60 overflow-y-auto"
      >
        <div v-if="productList.length === 0" class="p-2 text-slate-500">
          No products found
        </div>
        <div v-else>
          <div
            v-for="product in productList"
            :key="product.product_id"
            @click.prevent="selectProduct(product)"
            class="p-2 hover:bg-woot-100 dark:hover:bg-woot-700 cursor-pointer flex items-center gap-2"
          >
            <span class="font-medium">{{ product.product_name }}</span>
            <span class="text-xs text-slate-500 ml-2">Qty: {{ product.quantity }}</span>
          </div>
          <div class="flex items-center justify-between p-2 border-t">
            <button @click="prevPage" :disabled="productCurrentPage === 1" class="text-xs px-2 py-1 rounded bg-slate-200 dark:bg-slate-600">Prev</button>
            <span class="text-xs">Page {{ productCurrentPage }} of {{ productTotalPages }}</span>
            <button @click="nextPage" :disabled="!productNextPage" class="text-xs px-2 py-1 rounded bg-slate-200 dark:bg-slate-600">Next</button>
          </div>
        </div>
      </div>
    </div>
  </label>
</template>